/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcMoreVerticalRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M12 2.5A1.75 1.75 0 1 0 12 6a1.75 1.75 0 0 0 0-3.5m-1.75 9.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m0 7.5a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0" />
    </svg>
  );
}
export default IcMoreVerticalRegular;
